import axios from "axios";

export const fetchAvailableOrganizations = async (parentCompanyId?: string) => {
  const query = parentCompanyId ? `?parentCompanyId=${parentCompanyId}` : "";
  return await axios.get(`/api/parentcompany/available-organizations${query}`);
};
